import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { obtenerSolicitudesPublicadas } from "../services/solicitudesService";


export default function SolicitudesPublicadas() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSolicitudes = async () => {
      try {
        const data = await obtenerSolicitudesPublicadas();
        setSolicitudes(Array.isArray(data) ? data : []);
      } catch (err) {
        setError("Error al cargar las solicitudes");
      } finally {
        setLoading(false);
      }
    };
    fetchSolicitudes();
  }, []);

  const mostrarDato = dato => (dato === null || dato === undefined || dato === "" || dato === 0) ? <span className="fst-italic text-muted">&lt;No indicado&gt;</span> : dato;

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-primary">Solicitudes Publicadas</h2>
      {loading && <div className="alert alert-info">Cargando...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-primary">
            <tr>
              <th>Consecutivo de Oficio</th>
              <th>Título de la Solicitud</th>
              <th>Nombre del Representante</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.length === 0 && !loading ? (
              <tr>
                <td colSpan="3" className="text-center">No hay solicitudes publicadas.</td>
              </tr>
            ) : (
              solicitudes.map(solicitud => (
                <tr key={solicitud.consecutivoOficioSolicitud}>
                  <td>
                    <Link className="link-primary fw-bold" to={`/detalle/${solicitud.consecutivoOficioSolicitud}`}>{mostrarDato(solicitud.consecutivoOficioSolicitud)}</Link>
                  </td>
                  <td>{mostrarDato(solicitud.tituloSolicitud)}</td>
                  <td>{mostrarDato(solicitud.nombreRepresentante)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
